/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q_Sifre_DegistirInputs */

const tr_faq_q_sifre_degistir = /** @type {(inputs: Faq_Q_Sifre_DegistirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şifremi nasıl değiştiririm?`)
};

const en_faq_q_sifre_degistir = /** @type {(inputs: Faq_Q_Sifre_DegistirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I change my password?`)
};

const de_faq_q_sifre_degistir = /** @type {(inputs: Faq_Q_Sifre_DegistirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie ändere ich mein Passwort?`)
};

const ru_faq_q_sifre_degistir = /** @type {(inputs: Faq_Q_Sifre_DegistirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как изменить пароль?`)
};

/**
* | output |
* | --- |
* | "How do I change my password?" |
*
* @param {Faq_Q_Sifre_DegistirInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_q_sifre_degistir = /** @type {((inputs?: Faq_Q_Sifre_DegistirInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q_Sifre_DegistirInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q_sifre_degistir(inputs)
	if (locale === "de") return de_faq_q_sifre_degistir(inputs)
	if (locale === "ru") return ru_faq_q_sifre_degistir(inputs)
	return tr_faq_q_sifre_degistir(inputs)
});